const WORDS = ["Pare-brise", "Réparation d'impact", "Vitrage automobile", "Calibration ADAS", "Rénovation d'optiques", "Intervention à domicile", "Haguenau 67500"];

export function Marquee() {
  const row = [...WORDS, ...WORDS];
  return (
    <div className="relative overflow-hidden border-y border-slate-200 bg-white py-7" aria-hidden="true" data-testid="services-marquee">
      <div className="marquee-track flex w-max gap-10">
        {row.map((w, i) => (
          <span key={i} className="flex items-center gap-10 whitespace-nowrap font-display text-4xl font-extrabold tracking-tight text-ag-ink sm:text-6xl">
            <span className={i % 2 ? "text-stroke" : ""}>{w}</span>
            <span className="text-ag-yellow">+</span>
          </span>
        ))}
      </div>
    </div>
  );
}
